import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { db } from '../../App';
import DocumentDetailsView from '../../components/DocumentDetailsView';
import { BlogDocumentType } from '../Blog';

const ActionDocumentDetails = () => {
    const { actionId, documentSlug } = useParams();
    const [documentItem, setDocumentItem] = useState<BlogDocumentType | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        const loadDocument = async () => {
            try {
                if(!actionId || !documentSlug) throw new Error('not-found');
                const firestoreActionIds: Record<string, string> = {
                    'otp-oi-cameroun': 'otp-oicameroun',
                    ralff: 'ralf',
                };
                const firestoreActionId = firestoreActionIds[actionId] || actionId;
                const snapshot = await getDoc(doc(db, `ouractions/${firestoreActionId}`));
                const result = snapshot.data()?.document as BlogDocumentType | undefined;
                if(!result || result.slug !== documentSlug) throw new Error('not-found');
                if(active) setDocumentItem(result);
            } catch {
                if(active) setDocumentItem(null);
            } finally {
                if(active) setLoading(false);
            }
        };
        loadDocument();
        return () => { active = false; };
    }, [actionId, documentSlug]);

    if(loading) return <div className="mx-auto my-[10vh] rounded-xl bg-white p-8 text-gray-500">Chargement...</div>;
    if(!documentItem) return (
        <div className="mx-auto my-[10vh] max-w-xl rounded-xl bg-white p-8 text-center">
            <h1 className="mb-3 text-2xl font-medium">Document de projet introuvable</h1>
            <Link className="text-primary underline" to="/">Retour à l'accueil</Link>
        </div>
    );

    return <DocumentDetailsView
        title={documentItem.title}
        description={documentItem.description}
        downloadUrl={documentItem.fileUrl}
        backTo={`/nos-actions/${actionId}`}
        backLabel="Retour au projet"
    />;
};

export default ActionDocumentDetails;
